import FormType from '../constants/form-type';
import FormVariant from '../constants/form-variant';
import ModelStore from '../logic/stores/model-store';
import UiStateStore from '../logic/stores/ui-state-store';
import ParamStore from '../logic/stores/param-store';

export default class LoginComponent extends React.Component {

    constructor(props) {
        super();

        this._onModelChange = this._onModelChange.bind(this);
        this._onUiChange = this._onUiChange.bind(this);
        this._onParamChange = this._onParamChange.bind(this);

        this.props = props;
        const componentId = props ? props.componentId : 0;

        this.state = {
            componentId: componentId,
            loginModel: ModelStore.getModel(componentId),
            uiState: UiStateStore.getModel(componentId),
            paramModel: ParamStore.getModel(componentId)
        };
    }

    componentDidMount() {
        ModelStore.addChangeListener(this._onModelChange);
        UiStateStore.addChangeListener(this._onUiChange);
        ParamStore.addChangeListener(this._onParamChange);
    }

    componentWillUnmount() {
        ModelStore.removeChangeListener(this._onModelChange);
        UiStateStore.removeChangeListener(this._onUiChange);
        ParamStore.removeChangeListener(this._onParamChange);
    }

    _onModelChange() {
        this.setState({loginModel: ModelStore.getModel(this.state.componentId)});
    }

    _onUiChange() {
        this.setState({uiState: UiStateStore.getModel(this.state.componentId)});
    }

    _onParamChange() {
        this.setState({paramModel: ParamStore.getModel(this.state.componentId)});
    }

    get isLogin() {
        return this.state.loginModel.formType === FormType.login;
    }

    get isRegister() {
        return this.state.loginModel.formType === FormType.register;
    }

    get isLoginOrRegister() {
        return this.isLogin || this.isRegister;
    }

    get isMinimal() {
        let isMinimal = false;
        this.state.uiState.form.formVariants.map((variant) => {
            isMinimal |= (variant === FormVariant.minimal);
        });
        return isMinimal;
    }

    get isPromo() {
        let isPromo = false;
        this.state.uiState.form.formVariants.map((variant) => {
            isPromo |= (variant === FormVariant.promo);
        });
        return isPromo;
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/login-component.js
 **/